export default [
    {
        name: 'tabelaModel',
        type: 'gltfModel',
        path: 'models/Table/testeTabela1.gltf'
    }
]